<template>
  <InputSearch
    ref="inputLote"
    :route="route"
    placeholder='Digite o lote que deseja procurar os materiais...'
    v-model="filters.lote"
    :filters="filters"
    @update="updateModel"
  />
</template>

<script>
import InputSearch from '@/components/Form/InputSearch';

export default {
  name: 'inputLote',

  components: {
    InputSearch,
  },

  data() {
    return {
      filters: {
        acao: this.item.acao ? this.item.acao : null,
      },
    };
  },

  methods: {
    updateModel(v) {
      this.$emit('updateModel', v);
    },
  },

  props: {
    route: {
      type: String,
    },
    item: {
      type: Object,
    },
  },
};
</script>
